import fromExponential from 'from-exponential'

import { BotReq } from 'src/store/bots/bots.api'

import { TOKEN_STORAGE_KEY } from './storage'

export function numberWithCommas(x: number) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export function urlFromBot({ protocol, domain, port }: BotReq) {
  return `${protocol}://${domain}:${port}`
}

export function detachedUrlFromBot({
  protocol,
  domain,
  port,
  detachedProtocol,
  detachedDomain,
  detachedPort,
}: BotReq) {
  if (!detachedProtocol) detachedProtocol = protocol
  if (!detachedDomain) detachedDomain = domain
  if (!detachedPort) detachedPort = port

  return `${detachedProtocol}://${detachedDomain}:${detachedPort}`
}

export function wsUrlFromBot({ protocol, domain, port }: BotReq) {
  const wsProtocol = protocol === 'https' ? 'wss' : 'ws'
  return `${wsProtocol}://${domain}:${port}`
}

export function botTokenStorageKey(baseURL: string) {
  return baseURL + '_' + TOKEN_STORAGE_KEY
}

export function numFormatter(value: any, decimals: number = 8): string {
  const n = Number(value)
  if (!isFinite(n)) return '-'
  if (Math.abs(n) >= 1_000_000_000) return (n / 1_000_000_000).toFixed(decimals) + 'B'
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(decimals) + 'M'
  if (Math.abs(n) >= 1_000) return (n / 1_000).toFixed(decimals) + 'K'
  return n.toFixed(decimals)
}

export function numFormatters(value: any, decimals: number = 2): string {
  const n = Number(value)
  if (!isFinite(n)) return '-'
  if (Math.abs(n) >= 1_000_000_000) return (n / 1_000_000_000).toFixed(decimals) + 'B'
  if (Math.abs(n) >= 1_000_000) return (n / 1_000_000).toFixed(decimals) + 'M'
  if (Math.abs(n) >= 1_000) return (n / 1_000).toFixed(decimals) + 'K'
  return n.toFixed(decimals)
}

export function toDecimal(num = 0, dp = 8) {
  if (num !== 0 && !num) return NaN
  return fromExponential(+num.toFixed(dp))
}
